// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1B2Ei","actionsCol":"EnrolledClinics_actionsCol__vqitF"};